import Param from '../param';
import Util from './libs/util';

let param = new Param();
let util = new Util();

export default class effectManager {
    constructor(){
        this.$svgTarget = $(".js__tsc-svg-write,.js__svg-write");

        this.conf = {
            // rotRadius : 20,
            // scrollInc : 0.27,
            // transY : 0.07,
            // transX : 0.35,
            // startPosiX : 0,
            // transZ : 1,
            // transRot:-0.45,
            // opacity : 80,

            rotRadius : 20,
            scrollInc : 0.5,
            transY : 1,
            transX : (window.innerWidth<=320)?0.4:0.5,
            startPosiX : 0,
            transZ : 1,
            transRot:-0.22,
            opacity : 80,


        }


    }
    show($target,type){

        if(type==="set"){

            if($target.hasClass("js__type-right")){
                TweenMax.set($target,{ opacity:0, x:-100});
            }else{
                TweenMax.set($target,{ opacity:0, x:100});
            }


        }else if(type==="out"){

            if($target.hasClass("type-low")){
                TweenMax.to($target,0.4, {
                    x:-100,
                    opacity:0,
                    ease: "Power2.easeIn",
                });
            }else{
                TweenMax.staggerTo($target,0.4, {
                    x:-100,
                    opacity:0,
                    ease: "Power2.easeIn",
                },0.05);
            }

        }else{

            TweenMax.staggerTo($target,0.7, {
                x:0,
                opacity:1,
                // scale:1,
                ease: "Power2.easeOut",
            },0.1);

            if(type==="show-slowDown"){
                TweenMax.to($target,10,{
                    x : -100,
                    delay:0.8
                });
            }


        }

    }
    svgInit(){
        TweenLite.set(this.$svgTarget.find(".js__write"), {drawSVG: "0%"});
    }
    svgAnimation($target,delayTime) {

        TweenMax.staggerTo($target.find(".js__write"), 0.3, {
            drawSVG: "100%",
            ease: Power2.easeOut,
            delay : delayTime
        }, .05);
    }
    splitText($target,type){

        if($target.length == 0){
          return;
        }

        if(type === "set"){

            for(let i=0; i<$target.length; i++){
                let _$t = $target.eq(i);
                let text = new SplitText(_$t, {type:"words,chars"}),
                    chars = text.chars;

                TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});
                TweenMax.set(chars,{ opacity:0, x:-300,z:-10,skewX:35});

            }

        }else if(type === "out"){
            TweenMax.staggerTo($target, 0.8,
                {
                    opacity:0, x:-300,z:-10,skewX:35,
                    // filter:"blur(0px)",
                    ease: "Power2.easeIn",
                },
                0.05
            );
        }else{
            TweenMax.staggerTo($target, 0.8,
                {
                    opacity:1, x:0,
                    // filter:"blur(0px)",
                    ease: "Power2.easeOut",
                },
                0.05
            );
            TweenMax.staggerTo($target, 1.2,
                {
                    z:0,skewX:0,
                    // ease: "Power2.easeOut",
                    ease : "Back.easeOut.config(2.0)"
                },
                0.05
            );
        }

    }
    splitTextKV($target,type){

        if($target.length == 0){
            return;
        }

        if(type === "set"){

            for(let i=0; i<$target.length; i++){
                let _$t = $target.eq(i);
                let text = new SplitText(_$t, {type:"words,chars"}),
                    chars = text.chars;

                // TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});
                // TweenMax.set(chars,{ opacity:0, x:100*util.rand(3.-3),y:100*util.rand(3,-3)});
                TweenMax.set(chars,{ opacity:0, scale:1.2});


            }

        }else if(type === "out"){

            TweenMax.staggerTo($target, 0.4,
                {
                    // opacity:0, x:-300,z:-10,skewX:35,
                    // filter:"blur(0px)",
                    opacity:0,
                    // scale:1.2,
                    ease: "Power2.easeIn",
                },
                0.01
            );
        }else{
            TweenMax.staggerTo($target, 0.8,
                {
                    opacity:1,
                    scale:1,
                    // y:0,
                    // filter:"blur(0px)",
                    ease: "Power2.easeOut",
                },
                0.05
            );
        }

    }
    scale($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, scale:0.4});
            TweenMax.set($target.find(".js__ef-target"),{ rotation:360});


        }else if(type==="out"){
            TweenMax.to($target,0.3, {
                opacity:0,
                scale:0.4,
                ease: "Power2.easeIn",
            });
            TweenMax.to($target.find(".js__ef-target"),0.3, {
                rotation:-360,
                ease: "Power2.easeIn",
            });
        }else{

            TweenMax.fromTo($target,0.5,
                {
                    scale:0.4,
                },
                {
                    scale:1,
                    ease: "Power2.easeOut",
                    // ease: "Expo.easeInOut",
                },0.1);
            TweenMax.fromTo($target.find(".js__ef-target"),1.2,
                {
                    rotation:360
                },
                {
                    rotation:0,
                    delay:0.3,
                    repeat:-1, yoyo:true, repeatDelay:0.1,
                    ease: "Power2.easeInOut",
                    // ease: "Expo.easeInOut",
                },0.1);
            TweenMax.to($target,0.4, {
                opacity:1,
                delay:0.1,
                // scale:1,
                ease: "Power2.easeIn",
            });



        }

    }
    bgImg($target,type){

        if(type==="set"){

            // TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});
            TweenMax.set($target.find(">* >*"),{ opacity:0,scale:1.2});


        }else if(type==="out"){

            TweenMax.to($target,0.4, {
                opacity:0,
                // z:1,
                scale:1.2,
                // z:0,
                ease: "Power2.easeIn",
            },0.1);


        }else{


            TweenMax.staggerTo($target,0.9, {
                opacity:1,
                // z:0,
                ease: "Power2.easeInOut",
            },0.9);

            TweenMax.to($target,10.0, {
                // z:0,
                scale:1,
                ease: "Power2.easeOut",
            },0.1);

        }

    }
    blur($target,type){

        if(type==="set"){

            // TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});
            if($target.attr("class").match(/-bg/g)){
                TweenMax.set($target,{ opacity:0,z:-10});
            }else{
                if(Useragnt.android)
                    TweenMax.set($target,{ opacity:0,scale:1.6});
                else
                    TweenMax.set($target,{ opacity:0,filter: "blur(10px)",scale:1.6});
            }




        }else if(type==="out"){

            TweenMax.to($target,0.6, {
                opacity:0,
                z:1,
                // z:0,
                ease: "Power2.easeIn",
            },0.1);


        }else{

            if($target.attr("class").match(/-bg/g)){
                TweenMax.staggerTo($target,0.8, {
                    opacity:1,
                    // z:0,
                    ease: "Power2.easeInOut",
                },0.5);

                TweenMax.to($target,8.2, {
                    z:0,
                    // z:0,
                    ease: "Power2.easeOut",
                },0.1);
            }else{
                if(Useragnt.android){
                    TweenMax.staggerTo($target,0.8, {
                        opacity:1,
                        scale:1,
                        // z:0,
                        ease: "Power2.easeOut",
                    },0.1);

                }else{
                    let _comp = ()=>{
                        setTimeout(()=>$target.attr("style","transform:matrix(1, 0, 0, 1, 0, 0);"),1e3);
                    }
                    TweenMax.staggerTo($target,0.8, {
                        opacity:1,
                        filter: "blur(0px)",
                        scale:1,
                        // z:0,
                        ease: "Power2.easeOut",
                    },0.1,_comp);

                }

            }


        }

    }
    bodyKv($target,type){

        if(type==="set"){

            if($target.attr("class").match(/-bg/g)){
                TweenMax.set($target,{ opacity:0});
            }else{
                TweenMax.set($target,{ opacity:0,scale:1.2});
            }

        }else if(type==="out"){

            if($target.attr("class").match(/-bg/g)){
                TweenMax.to($target,0.6, {
                    opacity:0,
                    ease: "Power2.easeIn",
                },0.1);
            }else{
                TweenMax.to($target,0.6, {
                    opacity:0,
                    // filter: "blur(10px)",
                    scale:1.2,
                    ease: "Power2.easeIn",
                },0.1);
            }

        }else{

            // if($target.attr("class").match(/-bg/g)){
            //     TweenMax.staggerTo($target,0.4, {
            //         opacity:1,
            //         // z:0,
            //         ease: "Power2.easeOut",
            //     },0.1);
            // }else{
                TweenMax.to($target,0.5, {
                    opacity:1,
                    scale:1,
                    ease: "Power2.easeOut",
                });
            // }




        }

    }
    panel($target,type){

        if(type==="set"){

            if(Useragnt.pc){
                TweenMax.set($target,{ x : -200+"%",scale:1.1 });
            }else{
                TweenMax.set($target,{ opacity:0 });
            }


        }else if(type==="out"){
            if(Useragnt.pc){
                TweenMax.staggerTo($target,0.4, {
                    x:-200+"%",
                    scale:1.1,
                    ease: "Power2.easeIn",
                },0.05);
            }else{
                TweenMax.to($target,0.4, {
                    opacity:0,
                    ease: "Power2.easeIn",
                });
            }

        }else{
            if(Useragnt.pc){
                TweenMax.staggerTo($target,1.1, {
                    x:0+"%",
                    scale:1,
                    ease: "Power2.easeOut",
                },0.1);
            }else{
                TweenMax.to($target,1.1, {
                    opacity:1,
                    ease: "Power2.easeOut",
                });
            }




        }

    }
    opacity($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity : 0});


        }else if(type==="out"){
            TweenMax.staggerTo($target,0.4, {
                opacity:0,
                // skewX:35,
                // y:100+"%",
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerTo($target,0.6, {
                opacity:0.97,
                // skewX:0,
                // y:0+"%",
                ease: "Power2.easeOut",
            },0.1);



        }

    }
    skew($target,type){

        if(type==="set"){

            TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});
            TweenMax.set($target.find(".js__ef-target"),{ opacity:0, x:-100+"%",z:-10,skewX:35});


        }else if(type==="out"){
            TweenMax.staggerTo($target.find(".js__ef-target"),0.6, {
                opacity:0, x:-100+"%",z:-10,skewX:35,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerTo($target.find(".js__ef-target"), 0.8,
                {
                    opacity:1, x:0+"%",
                    // filter:"blur(0px)",
                    ease: "Power2.easeOut",
                },
                0.05
            );
            TweenMax.staggerTo($target.find(".js__ef-target"), 1.2,
                {
                    z:0,skewX:0,
                    // ease: "Power2.easeOut",
                    ease : "Back.easeOut.config(2.0)"
                },
                0.05
            );



        }

    }
    scSkew($target,type){

        if(type==="set"){

            // TweenMax.set($target,{ "transform-style":"preserve-3d","perspective":10});

            TweenMax.set($target.find(".js__ef-target"),{ opacity:0, x:20,y:500,z:0,rotationY:270});


        }else if(type==="out"){
            let _comp = function () {
                TweenMax.set($target.find(".js__ef-target"),{ x:20,y:500});
            }
            TweenMax.to($target.find(".js__ef-target"),0.4, {
                opacity:0,rotationY:90,
                ease: "Power2.easeOut",
                onComplete:_comp
            });
        }else{

            TweenMax.staggerTo($target.find(".js__ef-target"), 0.6,
                {
                    opacity:1,
                    // filter:"blur(0px)",
                    ease: "Power2.easeOut",
                },
                0.12
            );
            TweenMax.staggerTo($target.find(".js__ef-target"), 1.2,
                {
                    y:0,
                    z:0,
                    x:0,
                    rotationY:0,
                    // delay:0.6,
                    ease: "Power2.easeOut",
                    // ease : "Back.easeOut.config(2.0)"
                },
                0.12
            );

            // console.log(util.random(1,3));
            //
            // TweenMax.staggerTo($target.find(".js__ef-target"), 10,
            //     {
            //     },
            //     0.12
            // );


        }

    }

    gnaviBg($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0});


        }else if(type==="out"){

            TweenMax.to($target,0.4, {
                opacity:0,
                ease: "Power2.easeIn",
            },0.1);


        }else{


            TweenMax.to($target,0.9, {
                opacity:1,
                // z:0,
                ease: "Power2.easeInOut",
            },0.9);

            // TweenMax.to($target,10.0, {
            //     // z:0,
            //     scaleY:1,
            //     ease: "Power2.easeOut",
            // },0.1);

        }

    }



}
